import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { Card, CardHeader, FormControlLabel, Typography } from "@mui/material";

import {
  NewDialog,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function Agreement({ agreement, setAgreement }) {
  const [open, setOpen] = useState(false);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const onChange = (event) => {
    setAgreement(event.target.checked);
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Stack>
              <Typography variant="caption" fontSize={10}>
                ضمن مطالعه با
                <Button sx={{ fontSize: 12 }} size="size" onClick={onOpen}>
                  "شرایط و قوانین"
                </Button>
                سامانه موافق هستم.
              </Typography>
            </Stack>
          }
          action={
            <FormControlLabel
              sx={{ width: 48 }}
              label={agreement ? "بله" : "خیر"}
              control={
                <Checkbox
                  size="small"
                  checked={agreement}
                  onChange={onChange}
                />
              }
            />
          }
        />
      </Card>

      <NewDialog label="payment" open={open} onClose={onClose} maxWidth="xs">
        <NewDialogTitle title="توافقنامه" onClose={onClose} />
        <NewDialogContent>
          <Stack p={2} rowGap={2}>
            <Typography variant="h3" align="center" color="primary">
              توافقنامه عضویت در سامانه لابراتور آنلاین دندانپزشکی دوردنت
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              این توافقنامه به منظور تعیین شرایط و ضوابط عضویت در سامانه
              لابراتور آنلاین دندانپزشکی دوردنت (که در ادامه "سامانه" نامیده
              می‌شود) تنظیم گردیده است. با عضویت در این سامانه، شما (که در ادامه
              "عضو" نامیده می‌شوید) موافقت خود را با شرایط زیر اعلام می‌کنید.
            </Typography>
            <Typography align="justify" variant="subtitle1" color="textPrimary">
              بند 1: اهداف و خدمات سامانه
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              1.1. سامانه دوردنت به منظور ارائه خدمات لابراتور دندانپزشکی آنلاین
              به دندانپزشکان و متخصصان مربوطه تاسیس شده است.
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              1.2. سامانه خدماتی از جمله ارسال و دریافت سفارشات، پیگیری وضعیت
              سفارشات و مشاوره تخصصی در زمینه درمان‌های دندانپزشکی را ارائه
              می‌دهد.
            </Typography>
            <Typography align="justify" variant="subtitle1" color="textPrimary">
              بند 2: شرایط عضویت
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              2.1. عضویت در سامانه مستلزم ارائه اطلاعات صحیح و دقیق توسط شماست و
              شما متعهد به به‌روزرسانی این اطلاعات در صورت تغییر آنها هستید.
            </Typography>

            <Typography variant="body1" color="textSecondary" align="justify">
              2.2. تنها افرادی که دارای مجوز رسمی دندانپزشکی هستند می‌توانند در
              این سامانه ثبت‌نام کنند.
            </Typography>
            <Typography align="justify" variant="subtitle1" color="textPrimary">
              بند 3: قوانین و مسئولیت‌ها
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              3.1. اعضا متعهد به رعایت کلیه قوانین و مقررات مربوط به فعالیت‌های
              دندانپزشکی هستند.
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              3.2. اعضا مسئول امنیت حساب کاربری خود بوده و باید از افشای اطلاعات
              ورود خود به هر شخص دیگری جلوگیری کنند.{" "}
            </Typography>
            <Typography align="justify" variant="subtitle1" color="textPrimary">
              بند 4: حق ثبت‌نام و خاتمه عضویت
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              4.1. دوردنت حق دارد هر زمان که بخواهد، درخواست عضویت را پذیرفته یا
              رد کند.
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              4.2. همچنین دوردنت می‌تواند عضویت شما را در صورتی که تخلفی از
              شرایط این توافقنامه مشاهده کند، به حالت تعلیق درآورد یا خاتمه دهد.
            </Typography>
            <Typography align="justify" variant="subtitle1" color="textPrimary">
              بند 5: حریم خصوصی
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              5.1 . دوردنت موظف است به حفاظت از اطلاعات شخصی شما و رعایت اصول
              حریم خصوصی متعهد باشد. اطلاعات شما تنها برای اهداف ارائه خدمات
              استفاده خواهد شد.
            </Typography>
            <Typography align="justify" variant="subtitle1" color="textPrimary">
              بند 6: قوانین عمومی
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              6.1. این توافقنامه تحت قوانین جمهوری اسلامی ایران تنظیم شده است و
              هرگونه اختلاف‌نظر باید در مراجع قانونی مربوطه پیگیری شود.
            </Typography>
            <Typography variant="body1" color="textSecondary" align="justify">
              6.2. هرگونه تغییر در این توافقنامه به اطلاع اعضا خواهد رسید و
              ادامه عضویت به معنای پذیرش این تغییرات است. تأیید و امضا: با ثبت
              نام در این سامانه، شما تأیید می‌کنید که شرایط و ضوابط فوق را
              مطالعه و قبول کرده‌اید. با آرزوی موفقیت برای شما در استفاده از
              خدمات دوردنت!
            </Typography>
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="medium"
            color="secondary"
            variant="contained"
            onClick={onClose}
          >
            بستن
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
